import styled, { keyframes } from 'styled-components';
import { BTN_SUBMIT, WHITE_COLOR } from '../../styles/variables';

const slideIn = keyframes`
  0% {
    /* opacity: 0 !important; */
    transform: translateY(150px);
  }
  100% {
    /* opacity: 1 !important; */
    transform: translateY(0);
  }
`;

const fadeIn = keyframes`
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
`;

export const EmailVerification = styled.div`
  overflow-y: scroll;
  width: 100%;
  height: 100vh;
  position: relative;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  color: rgba(0, 0, 0, 1);
  background: ${WHITE_COLOR};
  .default-loading {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
  .split-screen{
    width:70%;
    text-align:center;
    margin: auto;
    .info {
      font-size: 1.3rem !important;
    }
  }
  .full-screen{
    width:60%;
    margin-top: 5rem;
  }
  .container {  
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 1.5rem;
    animation: ${slideIn} 1.2s ease, ${fadeIn} 1.2s ease;
    .pds-logo {
      width: 60px;
      height: 60px;
      filter: invert(0%) sepia(93%) saturate(17%) hue-rotate(316deg) brightness(0%) contrast(100%);
      /* animation: ${slideIn} 1s ease 0s, ${fadeIn} 1s ease 0s; */
    }
    .heading {
      font-family: Oswald;
      font-size: 2rem;
      color: black;
      /* animation: ${slideIn} 1s ease 0.2s, ${fadeIn} 1s ease 0.2s; */
    }
    .info {
      font-display: block;
      font-family: 'Glacial Indifference';
      text-align: center;
      font-size: 1.4rem;
      /* animation: ${slideIn} 1s ease 0.3s, ${fadeIn} 1s ease 0.3s; */
    }
    
    .email-img {
      width: 45%;
    }
    .btn-container {
      display: flex;
      gap: 1rem;
      justify-content: space-between;
    }
    .btn-resend {
      background: ${BTN_SUBMIT};
      outline: none;
      border: none;
      border-radius: 64px;
      font-size: 1rem;
      padding: 0.5rem 1.5rem;
      cursor: pointer;
      position: relative;
    }
    .btn-logout {
      background: ${BTN_SUBMIT};
      outline: none;
      border: none;
      border-radius: 64px;
      font-size: 1rem;
      padding: 0.5rem 1.5rem;
      cursor: pointer;
      position: relative;
    }
    .btn-disabled {
      pointer-events: none;
      opacity: 0.5;
    }
    .btn-resend:hover:before, .btn-checkout:hover:before, .btn-logout:hover:before {
      opacity: 1;
      transform: translate(0, 0);
    }
    .btn-resend:before, .btn-checkout:before, .btn-logout:before {
      content: attr(data-hover);
      position: absolute;
      left: 0;
      width: 100%;
      text-transform: uppercase;
      opacity: 0;
      transform: translate(0, 80%);
      transition: all 0.2s ease-in-out;
    }
    .btn-resend:hover div, .btn-checkout:hover div, .btn-logout:hover div {
      opacity: 0;
      transform: translate(0, -80%);
    }
    .btn-resend div, .btn-checkout div, .btn-logout div {
    text-transform: uppercase;
    transition: all 0.2s ease-in-out;
  }
    .email-success-logo {
      width: 60px;
      height: 60px;
    }
    .btn-checkout {
      border: none;
      outline: none;
      background: ${BTN_SUBMIT};
      border-radius: 64px;
      padding: 0.5rem 1rem;
      cursor: pointer;
      position: relative;
    }
  }
  .error-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    /* justify-content: center; */
    gap: 1.5rem;
    margin-top: 10%;
    animation: ${slideIn} 1.2s ease, ${fadeIn} 1.2s ease;
    .pds-logo {
      width: 60px;
      height: 60px;
      filter: invert(0%) sepia(93%) saturate(17%) hue-rotate(316deg) brightness(0%) contrast(100%);
      /* animation: ${slideIn} 1s ease 0s, ${fadeIn} 1s ease 0s; */
    }
  }
  .verifyText{
    visibility: hidden;
  }
  .content{
    display: flex;
    flex-direction: column;
    align-items: center;
    row-gap:20px
  }
  //Email Verification success page CSS
  .email-success-logo {
    margin-top: 2rem;
  }
  .redirect-info {
    font-family: 'Open Sans';
    font-size: 1rem;
    a {
      color: #3f0aa8;
      /* transition: 0.5s all ease; */
    }
    a:hover {
      text-decoration: underline;
    }
  }
  @media only screen and (max-width: 1000px) {
    .container {
      width: 70%;
    }
  }
  @media only screen and (max-width: 900px) {
    .container {
      /* width: 70%; */
      .pds-logo,
      .email-success-logo {
        width: 50px;
        height: 50px;
      }
      .heading {
        font-size: 1.8rem;
      }
      .info {
        font-size: 1.2rem;
      }
      .btn-resend {
        font-size: 0.9rem;
        padding: 0.4rem 1.2rem;
        /* font-weight: 600; */
        cursor: pointer;
      }
      .redirect-info {
        font-size: 1rem;
      }
    }
  }
  @media only screen and (max-width: 700px) {
    .container {
      width: 90%;
      .pds-logo,
      .email-success-logo {
        width: 40px;
        height: 40px;
      }
      .heading {
        font-size: 1.7rem;
      }
      .info {
        font-size: 1rem;
      }
      .btn-resend {
        font-size: 0.7rem;
        padding: 0.4rem 1.2rem;
        /* font-weight: 600; */
        cursor: pointer;
      }
      .redirect-info {
        font-size: 0.75rem;
      }
    }
  }
  @media only screen and (max-height: 800px) {
    .full-screen {
      width:70%;
      margin-top: 1rem;
      .email-img {
        width: 40%;
      }
    }
  }
`;
